'use strict'

module.exports = {
  getEnv: function getEnv() {
    return this.getUrlParts().env
  },
  isLocal: function isLocal() {
    return this.getEnv() === 'local'
  },
  getDomain: function getDomain() {
    return this.getUrlParts().domain
  },
  getSubDomain: function getSubDomain() {
    return this.getUrlParts().subDomain
  },
  getFullDomain: function getFullDomain(urlParts) {
    var _urlParts = urlParts || this.getUrlParts()

    if (_urlParts.subDomain) {
      return _urlParts.subDomain + '.' + _urlParts.domain
    } else {
      return _urlParts.domain
    }
  },
  getApiUrl: function getApiUrl(apiName) {
    var urlParts = this.getUrlParts()
    var fullDomain = this.getFullDomain(urlParts)

    if (urlParts.type === 'www' || urlParts.type === 'my') {
      return urlParts.protocol + '://' + fullDomain + '/' + apiName
    } else if (urlParts.type === 'apps') {
      return urlParts.protocol + '://' + apiName + '.' + fullDomain
    } else if (urlParts.type === 'www2') {
      return urlParts.protocol + '://' + apiName + '.' + (urlParts.env !== 'prd' ? 'apps' + '-' + urlParts.env : 'apps') + '.' + urlParts.domain
    } else if (urlParts.type === 'local') {
      return urlParts.protocol + '://' + fullDomain + ':' + urlParts.port + '/' + apiName
    }

    return undefined
  },
  getApiRouterUrl: function getApiRouterUrl() {
    var urlParts = this.getUrlParts()

    if(urlParts.domain === 'wwtatc.com') {
      return urlParts.protocol + '://apirouter.' + this.getSubDomain() + '.wwt.com'
    }
    return this.getApiUrl('apirouter')
  },
  getApiForwardUrl: function getApiForwardUrl() {
    var apirouterUrl = this.getApiRouterUrl()

    if (apirouterUrl) {
      return apirouterUrl + '/api/forward'
    }

    return undefined
  },
  getCdnUrl: function getCdnUrl() {
    if (location) {
      var env = this.getEnv()
      if (env === 'dev' || env === 'local') {
        return location.protocol + '//www-dev.wwt.com/cdn/shared-cdn-assets/dist'
      } else if (env === 'tst' || env === 'test') {
        return location.protocol + '//www-tst.wwt.com/cdn/shared-cdn-assets/dist'
      } else if (env === 'prod' || env === 'prd') {
        return location.protocol + '//www.wwt.com/cdn/shared-cdn-assets/dist'
      }
    }
    return undefined
  },
  getUrlParts: function getUrlParts() {
    var hostPatterns = {
      local: new RegExp(/^.*?\.?(localhost)|(\d{1,3}(\.\d{1,3}){3})$/),
      www: new RegExp(/^(www-?([^2]*)?)\.(wwt\.com|telcobuy\.com)$/),
      digital: new RegExp(/^(www-?([^2]*)?)\.(wwtdigital\.com)$/),
      sharepoint: new RegExp(/^(wwt(dev|test)?)\.(sharepoint\.com)$/),
      beta: new RegExp(/^(beta-?([^2]*)?)\.(wwt\.com|telcobuy\.com)$/),
      my: new RegExp(/^(my-?([^.]*)?)\.(wwt\.com|telcobuy\.com)$/),
      apps: new RegExp(/^.*?\.?(apps-?(.*))\.(wwt\.com|telcobuy\.com|wwtatc\.com)$/),
      www2: new RegExp(/^(www2-?(.*)?)\.(wwt\.com)$/)
    }
    var protocol = undefined
    var host = undefined
    var port = undefined

    if (location) {
      if (location.protocol) {
        protocol = location.protocol.replace(':', '')
      }
      if (location.hostname) {
        host = location.hostname
      }
      if (location.port) {
        port = location.port.toString()
      }
    }

    var urlParts = {
      type: undefined,
      protocol: protocol,
      host: host,
      port: undefined,
      domain: undefined,
      subDomain: undefined,
      env: undefined
    }

    for (var pattern in hostPatterns) {
      if (hostPatterns.hasOwnProperty(pattern)) {
        var matches = urlParts.host.match(hostPatterns[pattern])
        if (matches) {
          urlParts.type = pattern
          if (pattern === 'local') {
            urlParts.domain = matches[0]
            urlParts.port = port
            urlParts.env = pattern
            return urlParts
          } else if (pattern === 'www' || pattern === 'beta' || pattern === 'my' || pattern === 'sharepoint' || pattern === 'digital') {
            urlParts.subDomain = matches[1]
            urlParts.env = matches[2] || 'prod'
            urlParts.domain = matches[3]
            return urlParts
          } else if (pattern === 'apps' || pattern === 'www2') {
            urlParts.subDomain = matches[1]
            urlParts.env = matches[2] || 'prd'
            urlParts.domain = matches[3]
            return urlParts
          }
        }
      }
    }
    return urlParts
  }
}
